import React from 'react';
import ExpandReviewButton from "@Pages/reviewWidget/components/ExpandReviewButton";
import ReviewShortContent from "@Pages/reviewWidget/components/ReviewShortContent";
import {Colors} from "@Styles/Colors.style";

function ReviewSnippet({review, isActive, setActiveReview}) {
    const activeClass = isActive ? "gb--review-snippet-small-active" : ""
    const shadowClass = review.visible ? "" : "gb--review-shadow"

    return (
        <div
            id={review?.ticketId ? review.ticketId + review.direction : review.dateTime}
            className={`gb--review-snippet gb--row gb--row-justify gb--row-middle gb--review-snippet-small ${activeClass} ${shadowClass}`}
            onClick={setActiveReview}
            style={{borderRightColor: Colors.secondaryColor}}
        >
            <ReviewShortContent review={review}/>
            <ExpandReviewButton
                isInactive={!isActive}
                direction="right"
            />
        </div>
    )
}

export default ReviewSnippet;